module.exports = __webpack_public_path__ + "static/media/selecta_eldiluvio.d4656839.png";